<template>
  <div class="legend">
    <div class="legend-title">
      <span class="text-primary semibold">Legenda dei posti</span>
      <vb-button
        class="btn pr-1 pl-1"
        :vb_options="{ size: 'sm', variant: 'ghost' }"
        role="button"
        @click="() => onHide()"
      >
        <vb-icon name="seat_blocked" :size="12"></vb-icon>
      </vb-button>
    </div>
    <div v-for="(obj, i) in list" :key="'entry-' + i" class="legend-row">
      <div>
        <seat-map-block :obj="obj" />
      </div>
      <div>
        {{ obj.legend }}
      </div>
    </div>
  </div>
</template>

<script>
import Block from "@liveflight/components/blocks/seat-map/seat-map-block.vue"; 

export default {
  name: "seat-map-info",
  components: {
    "seat-map-block": Block,
  },
  props: {
    list: Array,
    onHide: Function,
  }, 
};
</script>

<style lang="scss">
.legend {
  z-index: 9999 !important;
  background-color: white;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  padding: 0 10px;
  button {
    padding: 0;
  }

  @media screen and (max-width: 992px) {
    padding-top: 10px !important;
  }
}

.legend-title {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.legend-row {
  display: flex;
  gap: 10px;
  align-items: center;
}
</style>
